import React from "react";
import PropTypes from "prop-types";
import { truncate } from "../../utils/trunate";
import { formatAmount } from "../../utils/formatAmount";
import { Link } from "react-router-dom";

const ProductCard = ({ product, statusCart, onAddCart }) => {
  return (
    <div>
      <div className="bg-gray-100 border border-gray-200 rounded-lg shadow-lg p-4 h-full hover:bg-gray-200 cursor-pointer transition">
        <Link to={`/product/${product._id}`}>
          <img
            src={product.image_uri}
            alt={product.name}
            className="w-full h-40 object-contain rounded-md mb-4 flex justify-center"
          />
        </Link>

        <h2 className="text-lg font-semibold mb-2">
          <Link to={`/product/${product._id}`}>
            {truncate(product.name, 20)}
          </Link>
        </h2>
        <p className="text-gray-600 text-sm mb-4">
          {truncate(product.description, 50)}{" "}
        </p>
        <p className="font-bold text-lg">{formatAmount(product.amount)}</p>
        <div className="flex items-center justify-between">
          {product.in_stock ? (
            <div className="text-xs font-semibold text-green-500">In-Stock</div>
          ) : (
            <div className="text-xs font-semibold text-red-500">
              Out-Of-Stock
            </div>
          )}
        </div>
        <div className="mt-5">
          {product.in_stock ? (
            <a
              href="javascript:void(0)"
              onClick={onAddCart.bind(null, product)}
              className="md:flex items-center justify-center h-9 border-blue-500 px-8 rounded-md border -mt-3.5 hidden"
            >
              {" "}
              {statusCart(product)}{" "}
            </a>
          ) : null}
        </div>
        <div className="mt-4">
          {product.video_uri ? (
            <a
              href={product.video_uri}
              target="_blank"
              className="md:flex items-center justify-center h-9 px-8 rounded-md border bg-red-500 red-500 text-white -mt-3.5 hidden mr-3 w-full"
            >
              {" "}
              Watch Demo{" "}
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  product: PropTypes.object.isRequired,
};

export default ProductCard;
